import React, { Component } from 'react';

import Css from './LetsConnect.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import LetsConnectForm from '@components/LetsConnectForm/LetsConnectForm';

class LetsConnect extends Component {
  state = {
    cssClass: '',
    formActive: false,
    status: 0
  };

  componentDidMount = () => {
    window.addEventListener(
      'marketo-submitted-lets-connect',
      this.formSubmitted,
      true
    );
    window.addEventListener(
      'marketo-submitting-lets-connect',
      this.formSubmitting,
      true
    );
  };

  componentWillUnmount = () => {
    window.removeEventListener(
      'marketo-submitted-lets-connect',
      this.formSubmitted,
      true
    );
    window.removeEventListener(
      'marketo-submitting-lets-connect',
      this.formSubmitting,
      true
    );
  };

  formSubmitted = () => {
    this.submitingHandler(2);
  };

  formSubmitting = () => {
    this.submitingHandler(1);
  };

  areaClickHandler = () => {
    if (this.state.cssClass === Css.active) {
      this.setState({
        cssClass: '',
        formActive: false,
        status: 0
      });
    } else {
      this.setState({
        cssClass: Css.active,
        formActive: true,
        status: 0
      });
    }
  };

  submitingHandler = status => {
    this.setState({
      status: status
    });

    if (status === 2) {
      setTimeout(() => this.areaClickHandler(), 2000);
    }
  };

  render() {
    return (
      <div
        id={'lets-connect-form'}
        className={Css['lets-connect'] + ' ' + this.state.cssClass}
      >
        <div
          className={Css['click-area']}
          onClick={() => this.areaClickHandler()}
        >
          {this.state.formActive ? (
            <FontAwesomeIcon
              icon={['far', 'chevron-right']}
              className={'pointer'}
              onClick={this.props.click}
            />
          ) : (
            <FontAwesomeIcon
              icon={['far', 'chevron-left']}
              className={'pointer'}
              onClick={this.props.click}
            />
          )}
          <div className={Css.label}>
            <strong>Let's Connect</strong>
            &nbsp;&nbsp;866.779.7770
          </div>
        </div>
        {this.state.status === 1 && (
          <div className={Css.loader}>
            <FontAwesomeIcon icon={['far', 'spinner']} spin />
            Submitting ...
          </div>
        )}
        {this.state.status === 2 && (
          <div className={Css.loader}>
            <FontAwesomeIcon icon={['far', 'check-circle']} />
            Submited!
          </div>
        )}
        <div
          className={
            Css['form-container'] + ' flex-grow-1 p-4 position-relative'
          }
          style={this.state.status === 1 ? { overflow: 'hidden' } : {}}
        >
          <div>
            <LetsConnectForm click={this.areaClickHandler} />
          </div>
        </div>
      </div>
    );
  }
}

export default LetsConnect;



// WEBPACK FOOTER //
// ./src/components/LetsConnect/LetsConnect.js